import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form"
import { Button } from "@/components/ui/button"
import { DialogFooter } from "@/components/ui/dialog"
import { z } from "zod"
import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"
import { formSchema } from "./receive.schema"
import { Network, Token } from "@/config/tokens"
import TokenSelect from "@/components/forms/token.select"
import NetworkSelect from "@/components/forms/network.select"
import TokenAmountInput from "@/components/forms/token-amount.input"
import { getNetworksForToken } from "@/config"

interface WithdrawalFormProps {
  onSubmit: (data: z.infer<typeof formSchema>) => void;
}

export default function WithdrawalForm({ onSubmit }: WithdrawalFormProps) {
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      amount: "",
      network: Network.ETHEREUM,
      token: Token.USDC,
    },
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="flex flex-col gap-4 py-4">
          <div className="flex flex-row gap-2">
            <FormField
              name="token"
              render={({ field }) => (
                <FormItem className="w-6/12">
                  <FormLabel required>Select Token</FormLabel>
                  <TokenSelect
                    onChange={field.onChange}
                    defaultValue={field.value}
                  />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="network"
              render={({ field }) => (
                <FormItem className="w-6/12">
                  <FormLabel required>Network</FormLabel>
                  <NetworkSelect
                    networks={getNetworksForToken(form.watch("token") as Token)}
                    onChange={field.onChange}
                    defaultValue={field.value}
                  />
                </FormItem>
              )}
            />
          </div>
          <FormField
            name="amount"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Amount</FormLabel>
                <FormControl>
                  <TokenAmountInput token={form.watch("token")} field={field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
        <DialogFooter>
          <Button type="submit" className="w-full">
            Next
          </Button>
        </DialogFooter>
      </form>
    </Form>
  )
}
